import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the BanksPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-banks',
  templateUrl: 'banks.html',
})
export class BanksPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BanksPage');
  }

  goToPage(page, options = {}){
    this.navCtrl.push(page, options);
  }

}



// WEBPACK FOOTER //
// ./src/pages/banks/banks.ts